import styled, { css } from 'styled-components';
import { elevation, elevationTransition } from "../Styles/Utils";

export const Container = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Container", componentId: "sc-1j3hq02-0" })(["padding:16px;background-color:", ";border:2px solid ", ";border-radius:8px;", " color:", ";", " ", " ", ""],









(props) => props.theme.colors.Background,
(props) => props.borderColor || props.theme.colors['Level 1'],

elevationTransition,
(props) => props.theme.colors.Foreground,

(props) =>
!props.highlight &&
props.defaultHover &&
css(["cursor:pointer;&:hover{background-color:", ";", "}"],


props.theme.colors.ElementBackground,
elevation(1, true)),



(props) =>
!props.highlight &&
props.elevated &&
css(["background-color:", ";", ""],
props.theme.colors.ElementBackground,
elevation(1, true)),


(props) =>
props.highlight &&
css(["background-color:", ";transition:all 0.3s ease;border-color:transparent;"],
props.theme.colors['Level 1']));